import * as React from "react";
import * as _ from "lodash";
import IQuestionnaire, { Question } from "../../models/util/IQuestionnaire";
import { AppConstants, QuestionType } from "../../utils/AppConstants";
import IFrequency from "../../../../common/models/IFrequency";

interface QuestionnaireProps {
    question: IQuestionnaire;
    answer: any;
    updateHandler: (value: any, key: string) => void;
    hideComment?: boolean;
}

export default class QuestionnaireView extends React.Component<QuestionnaireProps> {
    getFormattedFrequency = (frequency: IFrequency, isFrequency: boolean) => {
        let formattedFrequency = "";
        if (!_.isEmpty(frequency)) {
            if (!_.isNull(frequency.count) && !_.isEmpty(frequency.unit)) {
                let unit = frequency.count === 1 ? AppConstants.FrequencyUnit[frequency.unit] + "s" : AppConstants.FrequencyUnit[frequency.unit];
                if (isFrequency) formattedFrequency = `${frequency.count} / ${unit} (Frequency)`;
                else formattedFrequency = `${frequency.count} ${unit} (Duration)`;
            }
        }
        return formattedFrequency;
    }
    getBooleanAnswerText = (answer: any) => {
        let toDisplay = answer.length > 0 && !_.isNull(answer[0]) && answer[0] ? answer[0].toString() : "";
        if (toDisplay === "true") {
            toDisplay = "Yes"
        } else if (toDisplay === "false") {
            toDisplay = "No"
        }
        return toDisplay;
    }
    mapTypeQuestion = (type: Question) => {
        let value;
        switch (type.type) {
            case QuestionType.BOOLEAN_TOGGLE: value = this.props.answer ? [this.props.answer[type.key]] : [];
                return <div className={`${value.toString()}-value`}>{this.getBooleanAnswerText(value)}</div>
            case QuestionType.FREQUENCY:
                let isFrequency = type.frequency.isDuration ? !type.frequency.isDuration : true;
                let formattedFrequency = this.props.answer !== undefined && this.props.answer !== null ? this.getFormattedFrequency(this.props.answer[type.key], isFrequency) : ""
                return <div>{formattedFrequency}</div>
            case QuestionType.INPUT: let name = type.placeholder;
                value = this.props.answer ? this.props.answer[type.key] : "";
                return <div>{`${value} ${value !== "" ? `(${name})` : ""}`}</div>
            case QuestionType.SELECT: value = this.props.answer ? this.props.answer[type.key] : "";
                return <div>{value}</div>
            case QuestionType.SELECTABLE_TOGGLE_LIST: value = this.props.answer ? [this.props.answer[type.key]] : [];
                return <div>{value}</div>;
            default: return null;
        }
    }
    render() {
        let { question, answer } = this.props;
        return <div className="questionnaire-component">
            <div className="question-text in-blk align-middle">
                {question.questionTitle}
            </div>
            <div className="dynamic-question in-blk align-middle">
                {question.answerList && question.answerList.map((type, index: number) => {

                    let cls = type.textSize ? type.textSize + " in-blk" : "in-blk col-50";
                    return <div key={index} className={cls}>
                        {this.mapTypeQuestion(type)}
                    </div>
                })}
            </div>
            {!this.props.hideComment && <div className="default-question in-blk comment align-middle">
                {answer ? answer.comment : ""}
            </div>}
        </div>
    }
}